import { Section } from '@globaleris/ui.library'
import { AddressTypeEnum } from '../../api/Argentia/enums/addressTypeEnum'
import { enumValuesToArray } from '../../helpers'
import i18n from '../../i18n'
import { SearchSelectOption } from '../../model/searchSelectOption'

export interface AddressDataFormModel {
  Id?: number
  fiscalAddressId?: number
  postalAddress?: string
  postalCode?: string
  postalCodeSearch?: SearchSelectOption
  municipality?: string
  province?: string
  country?: string
  municipalityId?: number
  provinceId?: number
  countryId?: number
  cupsId?: number
  paymentMethodId?: number
}

export const sectionsAddressData: Section[] = [
  {
    title: i18n.t('addresses:titles.billing'),
    inputs: [
      {
        name: 'postalAddress',
        required: true
      },
      {
        name: 'postalCode',
        required: true
      },
      {
        name: 'municipalityId',
        required: true
      },
      {
        name: 'provinceId',
        required: true
      },
      {
        name: 'countryId',
        required: true
      }
    ]
  }
]

export enum EnumAddressNumberType {
  Supply = 2,
  Billing = 3
}
export const EnumAddressNumberMap = enumValuesToArray(EnumAddressNumberType)

export type EnumAddressType = Omit<Record<keyof typeof AddressTypeEnum, string>, 'Fiscal'>
export type IsDirtyType = Omit<Record<keyof typeof AddressTypeEnum, boolean>, 'Fiscal'>

export const initialIsDirty: IsDirtyType = {
  Supply: false,
  Billing: false
}

export const addressTypeMap = Object.keys(EnumAddressNumberType)
  .map(key => {
    if (!Number(key)) {
      return {
        label: key as keyof EnumAddressType,
        value: EnumAddressNumberType[key] as AddressTypeEnum
      }
    }
    return null
  })
  .filter(e => e !== null) as {
  label: 'Supply' | 'Billing'
  value: AddressTypeEnum
}[]
